import { render, staticRenderFns } from "./orzmic.vue?vue&type=template&id=1d789446&"
import script from "./orzmic.vue?vue&type=script&lang=ts&"
export * from "./orzmic.vue?vue&type=script&lang=ts&"
import style0 from "./orzmic.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports